<template>
  <ClearLayout>
    <OfferPartnerRedirectModal
      :partner="cptdPartner"
      :url="cptdOfferUrl"
      @redirected="registerIntent"
    >
      <template #title>
        {{ cptdTitleRedirect }}
      </template>
      <template #alert-message>
        {{ cptdRedirectMessage }}
      </template>
    </OfferPartnerRedirectModal>
  </ClearLayout>
</template>

<script>
import { mapActions } from 'vuex'
import { PartnersName } from '@/helpers/partners/common'
// import { generateWhatsAppLink } from '@/helpers/whatsapp'
import ClearLayout from '@/layouts/ClearLayout.vue'
import { defineAsyncComponent } from 'vue'
import { JbClevertapEvent } from '~/data/clevertap/jb-clevertap'
const OfferPartnerRedirectModal = defineAsyncComponent(
  () =>
    import(
      '@/components/commomComponents/modals/OfferPartnerRedirectModal.vue'
    ),
)

export default {
  components: {
    ClearLayout,
    OfferPartnerRedirectModal,
  },
  computed: {
    cptdPartner() {
      const { partner } = this.$route?.params
      return partner?.toUpperCase() ?? ''
    },
    cptdOfferUrl() {
      if (this.$route.query?.url) return this.$route.query?.url

      switch (this.cptdPartner) {
        case 'KOIN':
          return 'https://credito.koin.com.br/emprestimo-jurosbaixos'
        default:
          // return generateWhatsAppLink({
          //   text: `Olá! Quero continuar minha solicitação de oferta com a ${this.cptdPartnerName}. Poderia me ajudar?`,
          // })
          // TODO: ROLLBACK WHEN WE HAVE A NEW WHATSAPP NUMBER
          return `${location.origin}/ofertas`
      }
    },
    cptdPartnerName() {
      return PartnersName[this.cptdPartner ?? ''] ?? ''
    },
    cptdTitleRedirect() {
      switch (this.cptdPartner) {
        default:
          return `Tudo certo! Finalize a contratação da sua oferta com a ${this.cptdPartnerName}`
      }
    },
    cptdRedirectMessage() {
      switch (this.cptdPartner) {
        default:
          return `Este serviço é uma parceria com a ${this.cptdPartnerName} e o processo continuará em seu site.`
      }
    },
  },
  mounted() {
    this.actEmitInfobipAffiliateOfferSelected({
      affiliate: this.cptdPartner,
    })
    this.actCleverTapPushEvent({
      eventName: JbClevertapEvent.AFFILIATE_OFFER_SELECTED,
      eventData: {
        ProductName: 'payroll-anticipation',
        CompanyName: this.cptdPartner,
        RedirectURL: this.cptdOfferUrl,
        Platform: navigator.userAgent,
      },
    })
  },
  methods: {
    ...mapActions({
      actInsertIntent: 'user/intent/actInsertIntent',
      actEmitInfobipAffiliateOfferSelected:
        'services/events/actEmitInfobipAffiliateOfferSelected',
      actCleverTapPushEvent: 'clevertap/actCleverTapPushEvent',
    }),
    registerIntent() {
      this.actCleverTapPushEvent({
        eventName: JbClevertapEvent.AFFILIATE_OFFER_REDIRECT,
        eventData: {
          ProductName: 'payroll-anticipation',
          CompanyName: this.cptdPartner,
          RedirectURL: this.cptdOfferUrl,
          Platform: navigator.userAgent,
        },
      })
      if (this.cptdPartner === 'KOIN') {
        this.actInsertIntent({
          identifier: 'PARTNER_KOIN_LOAN_REDIRECT',
        })
        return
      }
      this.actInsertIntent({
        identifier: `PARTNER_${this.cptdPartner}_REDIRECT`,
      })
    },
  },
}
</script>

<style lang="scss"></style>
